import * as React from 'react';
import { connect } from 'umi';
import * as AHooks from 'ahooks';
import copy from 'copy-to-clipboard';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import { ConnectState, ActivityDetailsPageModelState, UserModelState } from '@/models/connect';
import fCenterMessage from '@/components/fCenterMessage';
import fWeiXinShare, { buildWxSharePageUrl } from '@/components/fWeiXinShare';
import FModal from '@/components/FModal';
import FSimpleBar from '@/components/FSimpleBar';
import styles from './index.less';

import imgPageBg from './img/page_bg.png';
import imgMPageBg from './img/m_page_bg.png';
import imgTitle from './img/01_banner.png';
import imgSimulateBg from './img/simulate_bg.png';
import imgPlatform from './img/03_platform.png';
import imgTime from './img/04_time.png';
import imgBenefits from './img/05_benefits.png';
import imgOnboardBg from './img/onboard_bg.png';
import imgOnboard1 from './img/onboard_1.png';
import imgOnboard2 from './img/onboard_2.png';
import imgOnboard3 from './img/onboard_3.png';
import imgOnboard4 from './img/onboard_4.png';
import imgOnboard5 from './img/onboard_5.png';
import imgOnboard6 from './img/onboard_6.png';
import imgGrowthBg from './img/growth_bg.png';
import imgGrowthLv1 from './img/growth_lv1.png';
import imgGrowthLv2 from './img/growth_lv2.png';
import imgGrowthLv3 from './img/growth_lv3.png';
import imgGrowthLv4 from './img/growth_lv4.png';
import imgGrowthLv5 from './img/growth_lv5.png';
import imgGrowthLv6 from './img/growth_lv6.png';
import imgGrowthLv7 from './img/growth_lv7.png';
import imgCashback from './img/08_cashback.png';
import imgRules from './img/09_rules.png';
import imgFaqTitle from './img/faq_title.png';
import imgConsultTitle from './img/consult_title.png';
import imgConsultWechatQr from './img/consult_wechat_qr.png';
import imgConsultWorkWechatQr from './img/consult_workwechat_qr.jpg';
import imgConsultXiaohongshu from './img/consult_xiaohongshu.png';
import imgConsultWeibo from './img/consult_weibo.png';
import imgNav01 from './img/nav_01.png';
import imgNav02 from './img/nav_02.png';
import imgNav03 from './img/nav_03.png';
import imgNav04 from './img/nav_04.png';
import imgNav05 from './img/nav_05.png';
import imgNav06 from './img/nav_06.png';
import imgNav07 from './img/nav_07.png';
import imgNav08 from './img/nav_08.png';
import imgMTitle from './img/m_title.png';
import imgMIconCoin from './img/m_icon_coin.png';
import imgMIconFlash from './img/m_icon_flash.png';
import imgMIconBalloon from './img/m_icon_balloon.png';
import imgMCatNovel from './img/m_cat_novel.png';
import imgMCatComic from './img/m_cat_comic.png';
import imgMCatPodcast from './img/m_cat_podcast.png';
import imgMCatIllust from './img/m_cat_illust.png';
import imgMCatPhoto from './img/m_cat_photo.png';
import imgMCatMusic from './img/m_cat_music.png';
import imgMCatVideo from './img/m_cat_video.png';
import imgMCatPlugin from './img/m_cat_plugin.png';
import imgMBenOnboard from './img/m_ben_onboard.png';
import imgMBenGrowth from './img/m_ben_growth.png';
import imgMBenCashback from './img/m_ben_cashback.png';
import imgMSimFan from './img/m_sim_fan.png';
import imgMIconJoin from './img/m_icon_join.svg';
import imgMIconShare from './img/m_icon_share.svg';
import imgMIconConsole from './img/m_icon_console.svg';

const PLATFORM_RULE_URL =
  'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2?theme=%2Freader%3Fid%25M262cce8f2456ff0002e328eb2&w63518a=%2F';

const ONBOARD_GUIDE_URL =
  'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M26a0adac588b541003135827c&w06c513=%2F';

const NAV_ITEMS: { label: string; icon: string }[] = [
  { label: '平台优势', icon: imgNav01 },
  { label: '活动时间', icon: imgNav02 },
  { label: '活动权益', icon: imgNav03 },
  { label: '参与方式', icon: imgNav04 },
  { label: '消费补贴', icon: imgNav05 },
  { label: '活动规则', icon: imgNav06 },
  { label: '常见问题', icon: imgNav07 },
  { label: '活动咨询', icon: imgNav08 },
];

const ONBOARD_TASK_CODES = [
  'T0001008',
  'T0002001',
  'TS000074',
  'T0003004',
  'T0003002',
  'TS001301',
] as const;

const ONBOARD_TASK_TITLES = [
  '激活内测资格',
  '发布原创作品',
  '创建节点',
  '完成结算配置',
  '添加作品到节点',
  '邀请粉丝支持',
];
const ONBOARD_CONFIG_COUNT = 5;
const ONBOARD_DEAL_TARGET = 3;
const ONBOARD_CONFIG_REWARD = 50;
const ONBOARD_DEAL_REWARD = 50;

const GROWTH_TASK_CODES = [
  'TS001302',
  'TS001303',
  'TS001304',
  'TS001305',
  'TS001306',
  'TS001307',
  'TS001308',
] as const;
const GROWTH_SALES_CODE = 'T0003006';
const GROWTH_USERS_CODE = 'T0003007';
const ALL_TASK_CODES = [
  ...ONBOARD_TASK_CODES,
  ...GROWTH_TASK_CODES,
  GROWTH_SALES_CODE,
  GROWTH_USERS_CODE,
] as const;

const GROWTH_LEVEL_IMGS = [
  imgGrowthLv1,
  imgGrowthLv2,
  imgGrowthLv3,
  imgGrowthLv4,
  imgGrowthLv5,
  imgGrowthLv6,
  imgGrowthLv7,
];

const GROWTH_LEVELS: { sales: number; users: number; reward: number }[] = [
  { sales: 100, users: 5, reward: 30 },
  { sales: 300, users: 15, reward: 100 },
  { sales: 1000, users: 50, reward: 300 },
  { sales: 2000, users: 100, reward: 600 },
  { sales: 3000, users: 150, reward: 900 },
  { sales: 6000, users: 300, reward: 1800 },
  { sales: 10000, users: 500, reward: 3000 },
];

type FaqItem = {
  question: string;
  paragraphs: string[];
  bullets?: string[];
  tail?: string[];
};

const FAQ_ITEMS: FaqItem[] = [
  {
    question: '1、平台 0.63% 通道费是此次活动权益吗？',
    paragraphs: [
      '不是。仅扣除 0.63% 第三方通道费、不收平台服务费、快速结算与便捷提现属于 Freelog 长期交易能力。',
    ],
  },
  {
    question: '2、创作者入驻任务必须按照顺序完成吗？',
    paragraphs: [
      '建议按照页面指引依次完成。6个任务存在前后依赖，例如需要先发布原创作品，才能将作品添加到节点中。',
    ],
  },
  {
    question: '3、创作者入驻奖励如何获得？',
    paragraphs: [
      '完成“创作者入驻任务”中的任务 01 至 05，可解锁 50 元入驻配置奖励；完成任务 06，达成至少 3 笔有效付费交易，可再解锁 50 元首批成交奖励。两部分均完成，最高可获得 100 元入驻奖励。',
    ],
  },
  {
    question: '4、什么是有效付费交易？',
    paragraphs: ['有效付费交易须满足以下条件：'],
    bullets: [
      '订单支付成功；',
      '非创作者本人购买；',
      '非关联账号交易；',
      '不属于刷单、互刷或其他异常交易；',
      '订单及账号通过平台最终审核。',
    ],
    tail: ['免费订单、异常交易及未支付成功的订单不计入活动。'],
  },
  {
    question: '5、同一用户购买同一创作者的多个作品，如何计算有效付费用户？',
    paragraphs: ['同一付费用户在同一创作者名下多次购买：'],
    bullets: ['有效交易金额可以累计；', '有效付费用户人数仅计算 1 人。'],
  },
  {
    question: '6、成长等级的两个条件是否需要同时满足？',
    paragraphs: [
      '需要。创作者须同时达到对应等级要求的有效作品交易额和有效付费用户数，才能获得该等级奖励。',
      '例如达到 LV3 的 1,000 元交易额，但有效付费用户未达到 50 人，则暂不视为达成 LV3。',
    ],
  },
  {
    question: '7、成长等级激励是否累计发放？',
    paragraphs: [
      '不累计。活动结束后按最终达成的最高等级发放对应奖励，例如达成 LV6，则发放 LV6 奖励，不额外叠加 LV1 至 LV5。',
    ],
  },
  {
    question: '8、创作者奖励什么时候发放？',
    paragraphs: [
      '活动结束后平台统一核算数据并完成风控审核，审核通过后发放至用户“个人中心”-“活动奖励”中，具体以活动公告的奖励发放时间为准。',
    ],
  },
  {
    question: '9、粉丝是否需要提前领取补贴资格？',
    paragraphs: [
      '不需要。粉丝通过创作者分享入口完成作品付费，符合条件的订单在支付时会自动判断补贴资格。',
    ],
  },
  {
    question: '10、每天哪一笔订单可以享受补贴？',
    paragraphs: [
      '每个用户 ID 每个自然日仅有 1 次补贴机会，符合条件的订单按支付顺序判断，先完成支付的订单优先享受补贴。',
    ],
  },
  {
    question: '11、补贴金额如何使用？',
    paragraphs: [
      '符合条件的订单在支付时自动享受平台补贴，补贴金额直接抵扣订单应付金额，无需支付后再领取。',
    ],
  },
  {
    question: '12、当日补贴额度用完后还可以享受补贴吗？',
    paragraphs: [
      '平台每日补贴总额上限为 1,000 元，按支付顺序先到先得。达到上限后，当日后续订单不再享受补贴；次日额度重新开放。',
    ],
  },
  {
    question: '13、粉丝享受补贴会影响创作者结算吗？',
    paragraphs: [
      '不会。补贴由平台承担，不影响创作者结算收益；符合有效订单规则的补贴订单仍可计入成长等级任务。',
    ],
  },
];

const CONSULT_CHANNELS: {
  title: string;
  tag: string;
  img: string;
  round: boolean;
  action: 'save' | 'xiaohongshu' | 'weibo';
  actionLabel: string;
}[] = [
  {
    title: 'Freelog 官方公众号',
    tag: '微信公众号',
    img: imgConsultWechatQr,
    round: false,
    action: 'save',
    actionLabel: '保存二维码',
  },
  {
    title: 'Freelog 官方企业微信',
    tag: '企业微信',
    img: imgConsultWorkWechatQr,
    round: false,
    action: 'save',
    actionLabel: '保存二维码',
  },
  {
    title: 'Freelog 官方小红书',
    tag: '小红书',
    img: imgConsultXiaohongshu,
    round: true,
    action: 'xiaohongshu',
    actionLabel: '前往小红书',
  },
  {
    title: 'Freelog 官方微博',
    tag: '微博',
    img: imgConsultWeibo,
    round: true,
    action: 'weibo',
    actionLabel: '前往微博',
  },
];

const XIAOHONGSHU_URL =
  'https://www.xiaohongshu.com/user/profile/64c0d3810000000014039a75';
const WEIBO_URL = 'https://weibo.com/freelogofficial';

const PLATFORM_POINTS: { icon: string; title: string; titleColor: string; lines: string[] }[] = [
  {
    icon: imgMIconCoin,
    title: '收益更多留给创作者',
    titleColor: '#044088',
    lines: ['不收平台服务费', '仅扣除0.65%第三方支付手续费'],
  },
  {
    icon: imgMIconFlash,
    title: '结算更快',
    titleColor: '#8b5913',
    lines: ['交易完成后，当天可提现'],
  },
  {
    icon: imgMIconBalloon,
    title: '提现更省心',
    titleColor: '#a31212',
    lines: ['每24小时即可发起提现', '1个工作日到账'],
  },
];

const CREATOR_TYPES: { icon: string; name: string; desc: string }[] = [
  { icon: imgMCatNovel, name: '小说', desc: '短篇、连载、合集\n与专栏内容' },
  { icon: imgMCatComic, name: '漫画', desc: '单话、连载、短篇集\n与数字画册' },
  { icon: imgMCatPodcast, name: '播客', desc: '单期音频、系列节目\n与付费专题' },
  { icon: imgMCatIllust, name: '插画', desc: '原创插画、角色设定\n与数字画集' },
  { icon: imgMCatPhoto, name: '摄影', desc: '摄影作品、主题图集\n与素材包' },
  { icon: imgMCatMusic, name: '音乐', desc: '单曲、专辑、伴奏\n与音频素材' },
  { icon: imgMCatVideo, name: '视频', desc: '课程、短片、系列视频\n与幕后内容' },
  { icon: imgMCatPlugin, name: '主题/插件开发', desc: '主题模板、插件工具\n与数字组件' },
];

const BENEFIT_CARDS: { icon: string; title: string; desc: string; amount: string; color: string }[] =
  [
    {
      icon: imgMBenOnboard,
      title: '入驻权益',
      desc: '完成Freelog入驻并达成 3 笔付费交易',
      amount: '奖励100元',
      color: '#b97106',
    },
    {
      icon: imgMBenGrowth,
      title: '成长等级激励',
      desc: '冲刺LV.1~LV.7交易额目标，赢取加码收益',
      amount: '最高3000元',
      color: '#096e2c',
    },
    {
      icon: imgMBenCashback,
      title: '粉丝消费补贴',
      desc: '粉丝支持创作者，活动首月享消费补贴',
      amount: '支付立减20%',
      color: '#a31212',
    },
  ];

const ONBOARD_MOBILE = [
  {
    no: '01',
    title: '激活内测资格',
    desc: '注册账号并完成 Freelog 内测激活。',
  },
  {
    no: '02',
    title: '发布原创作品',
    desc: '上架成功至少1个原创资源。',
  },
  {
    no: '03',
    title: '创建节点',
    desc: '创建节点并激活主题，让粉丝能访问你的节点。',
  },
  {
    no: '04',
    title: '完成结算配置',
    desc: '配置节点结算信息，为作品定价、交易提现做好准备。',
  },
  {
    no: '05',
    title: '添加作品到节点',
    desc: '将已发布作品添加到节点中，确保主页内作品可访问。',
  },
  {
    no: '06',
    title: '完成首批成交',
    desc: '将主页分享给粉丝，完成 至少 3 笔 真实成交。',
  },
];

const CASHBACK_FACTS: { label: string; value: string }[] = [
  { label: '补贴活动周期', value: '活动开启后前 30 天' },
  { label: '补贴比例', value: '订单应付金额的 20%' },
  { label: '补贴上限', value: '单笔最高补贴 5 元' },
  { label: '补贴方式', value: '支付时自动抵扣' },
  { label: '参与资格', value: '每位用户每天首笔订单可享补贴' },
  { label: '每日额度', value: '每日补贴总额上限为 1000 元，额度补完即止' },
];

function useIsMobile() {
  const [mobile, setMobile] = React.useState(
    () => typeof window !== 'undefined' && window.innerWidth < 1100,
  );
  React.useEffect(() => {
    const mql = window.matchMedia('(max-width: 1099px)');
    const apply = () => setMobile(mql.matches);
    apply();
    mql.addEventListener('change', apply);
    return () => mql.removeEventListener('change', apply);
  }, []);
  return mobile;
}

function isWeChatBrowser() {
  return navigator.userAgent.toLowerCase().includes('micromessenger');
}

function isTopWindow() {
  try {
    return self === self.top;
  } catch {
    return false;
  }
}

const SIMULATE_SALES_MIN = 100;
const SIMULATE_SALES_MAX = 10000;
const SIMULATE_BAR_WIDTH = 400;
const SIMULATE_THUMB_SIZE = 24;
/** 原本到账 = 售出作品总额 × 99.37%（扣除 0.63% 支付手续费） */
const SIMULATE_ORIGIN_RATE = 0.9937;
const SIMULATE_ONBOARD_REWARD = 100;
const SIMULATE_GROWTH_LEVELS: { minSales: number; reward: number }[] = [
  { minSales: 10000, reward: 3000 },
  { minSales: 6000, reward: 1800 },
  { minSales: 3000, reward: 900 },
  { minSales: 2000, reward: 600 },
  { minSales: 1000, reward: 300 },
  { minSales: 300, reward: 100 },
  { minSales: 100, reward: 30 },
];

function roundCents(amount: number) {
  return Math.round(amount * 100) / 100;
}

function growthRewardBySales(sales: number) {
  const level = SIMULATE_GROWTH_LEVELS.find((item) => sales >= item.minSales);
  return level?.reward ?? 0;
}

function formatYen(amount: number, fractionDigits: number) {
  return `¥${amount.toFixed(fractionDigits)}`;
}

function formatYenAuto(amount: number) {
  const rounded = roundCents(amount);
  if (Number.isInteger(rounded)) {
    return `¥${rounded}`;
  }
  return `¥${rounded.toFixed(2)}`;
}

type TaskRecord = {
  code?: string;
  completionTime: number;
};

function taskCompletionTime(records: TaskRecord[], code: string) {
  const byCode = records.find((item) => item.code === code);
  if (byCode) {
    return Number(byCode.completionTime) || 0;
  }
  const index = (ALL_TASK_CODES as readonly string[]).indexOf(code);
  return (index >= 0 ? Number(records[index]?.completionTime) : 0) || 0;
}

function miniBarWidth(current: number, target: number) {
  if (target <= 0 || current >= target) {
    return '100%';
  }
  if (current <= 0) {
    return '5px';
  }
  return `${(current / target) * 100}%`;
}

function consoleUrl(path: string) {
  return FUtil.Format.completeUrlByDomain('console') + path;
}

type UserNodeItem = {
  nodeId: number;
};

async function listUserNodes(): Promise<UserNodeItem[]> {
  const { data }: {
    data?: {
      dataList?: UserNodeItem[];
    };
  } = await FServiceAPI.Node.nodes({ limit: 100 });
  return data?.dataList || [];
}

async function pickNodeWithoutTheme(): Promise<number | null> {
  const nodes = await listUserNodes();
  if (nodes.length === 0) {
    return null;
  }
  for (const node of nodes) {
    const { data }: { data?: { nodeThemeId?: string } } = await FServiceAPI.Node.details({
      nodeId: node.nodeId,
    });
    if (!data?.nodeThemeId) {
      return node.nodeId;
    }
  }
  return nodes[0].nodeId;
}

async function ensureLogin(): Promise<boolean> {
  if (FUtil.Tool.getUserIDByCookies() === -1) {
    await FServiceAPI.User.currentUserInfo();
    return false;
  }
  return true;
}

function DatePatch({
  left,
  top,
  width,
  height,
  fontSize,
  letterSpacing,
  background,
  text,
}: {
  left: number;
  top: number;
  width: number;
  height: number;
  fontSize: number;
  letterSpacing: number;
  background: string;
  text: string;
}) {
  return (
    <div
      className={styles.datePatch}
      style={{
        left,
        top,
        width,
        height,
        fontSize,
        letterSpacing,
        background,
        lineHeight: `${height}px`,
      }}
    >
      {text}
    </div>
  );
}

function copyServiceEmail() {
  copy('service@freelog.com', { format: 'text/plain' });
  fCenterMessage({ message: '复制成功' });
}

async function saveConsultImage(src: string, filename: string) {
  try {
    const res = await fetch(src);
    const blob = await res.blob();
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    link.click();
    URL.revokeObjectURL(url);
    fCenterMessage({ message: '保存成功' });
  } catch {
    fCenterMessage({ message: '保存失败' });
  }
}

function RulesLink({ children, onClick }: { children: React.ReactNode; onClick: () => void }) {
  return (
    <button type='button' className={styles.rulesLink} onClick={onClick}>
      {children}
    </button>
  );
}

function RulesContent({ endTimeText }: { endTimeText: string }) {
  return (
    <>
      <section className={styles.rulesBlock}>
        <h3>一）活动期限与成交认定</h3>
        <p>
          1.活动有效成交统计截止至 {endTimeText}。截止时间后完成的交易，不计入本次活动奖励。
        </p>
        <p>2.订单是否计入活动，以订单支付成功时间及平台最终审核结果为准。</p>
        <p>
          3.参与活动的作品须在活动结算完成后继续在 Freelog
          资源市场保持上架不少于 12 个月，以保障用户的正常购买和使用体验。
        </p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>二）参与作品要求</h3>
        <p className={styles.rulesIntro}>参与活动的作品须满足以下要求：</p>
        <p>1.严禁上传空白文件、无实质内容的资源，以及其他任何形式的虚假或无意义资源。</p>
        <p>2.严禁上传专门为套取活动奖励而制作的低质资源。</p>
        <p>3.作品须符合 Freelog 平台相关发布及管理规范。</p>
        <p className={styles.rulesNote}>
          经平台审核认定不符合上述要求的行为，不计入活动评选及奖励结算。
        </p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>三）原创与版权要求</h3>
        <p>1.用户发布的资源须为原创作品，禁止抄袭、搬运或未经授权使用他人作品。</p>
        <p>
          2.对于合作创作的资源，应由参与各方协商一致，并通过一个指定账号统一发布，严禁多人使用各自账号重复发布相同或相似的合作资源。
        </p>
        <p>
          3.用户须确保对所发布的资源拥有完整著作权，或已取得合法、有效且必要的授权。
        </p>
        <p>
          4.若因作品侵权、授权不完整或其他版权问题引发的争议及法律责任，由发布用户自行承担，Freelog
          平台不承担由此产生的相关责任。
        </p>
        <p className={styles.rulesNote}>
          经平台审核认定不符合上述要求的行为，则平台有权直接取消作品的参与资格，已分配的全部奖金即时取消或追回。
        </p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>四）粉丝消费补贴规则</h3>
        <p>1.活动周期：粉丝消费补贴活动自活动开始之日起，持续前 30 个自然日</p>
        <p>2.补贴比例：符合条件的订单按订单应付金额的 20% 享受补贴，单笔最高补贴 5 元。</p>
        <p>
          3.参与次数：每个用户 ID
          每个自然日最多享受 1 次补贴，系统以订单支付时间判断当日补贴资格。
        </p>
        <p>4.补贴方式：符合条件的订单在支付时自动享受平台补贴，补贴金额直接抵扣订单应付金额。</p>
        <p>5.每日额度：平台每日补贴总额上限为 1000 元，按支付顺序先到先得，补完即止。</p>
        <p>6.费用承担：补贴成本由 Freelog 平台承担，不影响创作者的作品结算金额。</p>
        <p>7.无效情形：创作者本人购买、关联账户交易、刷单及其他异常交易，不参与补贴。</p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>五）奖励审核与反作弊机制</h3>
        <p className={styles.rulesIntro}>
          为保障活动公平，平台将对参与账号及交易数据进行审核，包括但不限于以下内容：
        </p>
        <p className={styles.rulesWrap}>
          1.
          账号及主体核验：平台将核验参与账号、结算主体及身份信息。同一主体控制多个账号、批量注册账号或存在异常登录行为的，平台可对相关账号合并计算，或取消其活动资格。
        </p>
        <p className={styles.rulesWrap}>
          2.
          关联关系识别：平台可能结合账号、设备、网络环境、支付账户及结算关系等信息，识别创作者本人购买、关联账户互刷及同一群体批量交易等异常行为。
        </p>
        <p>3. 交易真实性核验：以下偏离正常消费行为的订单，可能被认定为异常交易：</p>
        <div className={styles.rulesSubs}>
          <p>短时间内集中下单；</p>
          <p>批量小额订单；</p>
          <p>异常高频交易；</p>
          <p>其他疑似套取返现或活动奖励的行为。</p>
        </div>
        <p className={styles.rulesWrap}>
          4.有效付费用户认定：同一付费用户在同一创作者名下多次购买，仅计为 1
          名有效付费用户。虚假用户、关联用户或被系统判定为风险用户的，不计入有效人数。
        </p>
        <p className={styles.rulesWrap}>
          5.
          返现套利识别：批量账号轮换下单、同一设备或关联账户重复获取返现、创作者与购买用户串通交易等行为，不享受返现或活动奖励。
        </p>
        <p className={styles.rulesWrap}>
          6.
          人工复核：命中风险规则、数据明显异常、奖励金额较高或被用户投诉的账号，将进入人工复核。平台可要求相关用户补充原创证明、授权材料或交易真实性说明。
        </p>
        <p className={styles.rulesNote}>
          具体风控指标、判断阈值及审核策略将根据实际风险情况动态调整，相关信息不对外公开。
        </p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>六）违规处理</h3>
        <p>
          如用户、作品或交易存在违规、作弊、侵权或其他异常情形，平台有权根据实际情况采取以下一项或多项措施：
        </p>
        <div className={styles.rulesSubs}>
          <p>剔除异常订单、用户或作品；</p>
          <p>重新核算活动数据及奖励金额；</p>
          <p>暂停奖励审核或发放；</p>
          <p>取消作品或账号的活动资格；</p>
          <p>取消尚未发放的奖励；</p>
          <p>追回已经发放的返现或奖励；</p>
          <p>限制相关账号参与后续平台活动；</p>
          <p>根据平台规范采取其他必要措施。</p>
        </div>
        <p className={styles.rulesNote}>
          所有用户均须遵守平台规范，如用户违反平台管理规范，平台有权按照本条规则进行处理。<RulesLink onClick={() => self.open(PLATFORM_RULE_URL)}>《Freelog平台管理规范》</RulesLink>
        </p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>七）投诉与申诉</h3>
        <p>
          活动期间开放投诉通道。用户可联系 Freelog
          官方工作人员，或发送邮件对涉嫌违规的作品或用户进行投诉。<RulesLink onClick={copyServiceEmail}>service@freelog.com</RulesLink>
        </p>
        <p className={styles.rulesNote}>投诉内容须至少包含：</p>
        <div className={styles.rulesSubs}>
          <p>被投诉作品名称；</p>
          <p>被投诉作品链接；</p>
          <p>涉嫌违规的具体原因；</p>
          <p>可用于核实情况的相关证明材料。</p>
        </div>
        <p className={styles.rulesNote}>投诉信息不完整的，平台可能无法受理。</p>
      </section>

      <section className={styles.rulesBlock}>
        <h3>八）其他说明</h3>
        <p>1.活动数据及奖励结果以 Freelog 平台最终审核和结算结果为准。</p>
        <p>
          2.如对活动规则或审核结果存在疑问，可联系官方工作人员，或发送邮件至<RulesLink onClick={copyServiceEmail}>service@freelog.com</RulesLink>
        </p>
        <p>3.在法律法规允许的范围内，本活动最终解释权归 Freelog 所有。</p>
      </section>
    </>
  );
}

interface PaymentSubsidyProps {
  activityDetailsPage: ActivityDetailsPageModelState;
  user: UserModelState;
}

function PaymentSubsidy({ activityDetailsPage, user }: PaymentSubsidyProps) {
  const ref_platform = React.useRef<HTMLDivElement>(null);
  const ref_time = React.useRef<HTMLDivElement>(null);
  const ref_benefits = React.useRef<HTMLDivElement>(null);
  const ref_onboard = React.useRef<HTMLDivElement>(null);
  const ref_cashback = React.useRef<HTMLDivElement>(null);
  const ref_rules = React.useRef<HTMLDivElement>(null);
  const ref_faq = React.useRef<HTMLDivElement>(null);
  const ref_consult = React.useRef<HTMLDivElement>(null);

  const sectionRefs = [
    ref_platform,
    ref_time,
    ref_benefits,
    ref_onboard,
    ref_cashback,
    ref_rules,
    ref_faq,
    ref_consult,
  ];

  const [$activated, set$activated, get$activated] = FUtil.Hook.useGetState<number>(0);
  const [$scroller, set$scroller] = React.useState<HTMLElement | null>(null);
  const [$panelCollapsed, set$panelCollapsed] = React.useState(false);
  const [$onboardDone, set$onboardDone] = FUtil.Hook.useGetState<boolean[]>(
    ONBOARD_TASK_CODES.map(() => false),
  );
  const [$dealProgress, set$dealProgress] = FUtil.Hook.useGetState(0);
  const [$growthDone, set$growthDone] = FUtil.Hook.useGetState<boolean[]>(
    GROWTH_TASK_CODES.map(() => false),
  );
  const [$growthSales, set$growthSales] = FUtil.Hook.useGetState(0);
  const [$growthUsers, set$growthUsers] = FUtil.Hook.useGetState(0);
  const [$simulateSales, set$simulateSales] = React.useState(SIMULATE_SALES_MIN);
  const [$simulateTab, set$simulateTab] = React.useState<'creator' | 'fan'>('creator');
  const [$faqOpen, set$faqOpen] = React.useState(-1);
  const [$mShareOpen, set$mShareOpen] = React.useState(false);
  const [$mJoinOpen, set$mJoinOpen] = React.useState(false);
  const isMobile = useIsMobile();
  const simulateOrigin = roundCents($simulateSales * SIMULATE_ORIGIN_RATE);
  const simulateGrowth = growthRewardBySales($simulateSales);
  const simulateTotal = roundCents(simulateOrigin + SIMULATE_ONBOARD_REWARD + simulateGrowth);
  const simulateBarRatio =
    ($simulateSales - SIMULATE_SALES_MIN) / (SIMULATE_SALES_MAX - SIMULATE_SALES_MIN);
  const simulateBarFill = simulateBarRatio * SIMULATE_BAR_WIDTH;
  const simulateThumbLeft = Math.min(
    Math.max(simulateBarFill - SIMULATE_THUMB_SIZE / 2, 0),
    SIMULATE_BAR_WIDTH - SIMULATE_THUMB_SIZE,
  );

  AHooks.useMount(() => {
    if (!isMobile || !isTopWindow() || !isWeChatBrowser()) {
      return;
    }
    if (!activityDetailsPage.pageTitle) {
      return;
    }
    self.location.replace(
      buildWxSharePageUrl({
        title: activityDetailsPage.pageTitle,
        desc: activityDetailsPage.description,
        imgUrl: activityDetailsPage.cover,
      }),
    );
  });

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    const [{ data }, { data: userData }, { data: salesRecord }, { data: usersRecord }]: [
      { data: TaskRecord[] },
      { data?: { userType?: 0 | 1 } },
      {
        data?: {
          metaInfo?: {
            transactionAmountSum?: number;
          };
        } | null;
      },
      {
        data?: {
          metaInfo?: {
            paymentUserNum?: number;
          };
        } | null;
      },
    ] = await Promise.all([
      FServiceAPI.Activity.statisticTaskRecords({
        codes: [...ALL_TASK_CODES],
      }),
      FServiceAPI.User.currentUserInfo(),
      FServiceAPI.Activity.getLastTaskRecordDetail({
        taskConfigCode: GROWTH_SALES_CODE,
      }),
      FServiceAPI.Activity.getLastTaskRecordDetail({
        taskConfigCode: GROWTH_USERS_CODE,
      }),
    ]);
    const records = data || [];
    const onboardDone = ONBOARD_TASK_CODES.map(
      (code) => taskCompletionTime(records, code) >= 1,
    );
    // 已激活内测资格（userType === 1）即视为任务 01 完成，与 Widget 等活动一致
    if (userData?.userType === 1) {
      onboardDone[0] = true;
    }
    set$onboardDone(onboardDone);
    set$dealProgress(taskCompletionTime(records, ONBOARD_TASK_CODES[5]));
    set$growthDone(
      GROWTH_TASK_CODES.map((code) => taskCompletionTime(records, code) >= 1),
    );
    set$growthSales(Number(salesRecord?.metaInfo?.transactionAmountSum) || 0);
    set$growthUsers(Number(usersRecord?.metaInfo?.paymentUserNum) || 0);
  });

  const position = AHooks.useScroll($scroller);

  React.useEffect(() => {
    let next = 0;
    for (let i = sectionRefs.length - 1; i >= 0; i -= 1) {
      const top = sectionRefs[i].current?.getBoundingClientRect().top;
      if (top !== undefined && top <= 90) {
        next = i;
        break;
      }
    }
    if ($scroller) {
      const remain =
        $scroller.scrollHeight - $scroller.scrollTop - $scroller.clientHeight;
      if (remain <= 16) {
        next = sectionRefs.length - 1;
      }
    }
    if (next !== get$activated()) {
      set$activated(next);
    }
  }, [position, $scroller]);

  function scrollToSection(index: number) {
    const top = sectionRefs[index].current?.getBoundingClientRect().top;
    $scroller?.scrollBy({
      top: (top || 0) - (isMobile ? 0 : 80),
      behavior: 'smooth',
    });
  }

  const configDoneCount = $onboardDone
    .slice(0, ONBOARD_CONFIG_COUNT)
    .filter(Boolean).length;
  const totalDoneCount = $onboardDone.filter(Boolean).length;
  const pendingTaskIndex = $onboardDone.findIndex((done) => !done);
  const pendingTaskTitle =
    pendingTaskIndex === -1 ? '已完成' : ONBOARD_TASK_TITLES[pendingTaskIndex];
  const dealDoneCount = $onboardDone[5]
    ? ONBOARD_DEAL_TARGET
    : Math.min($dealProgress, ONBOARD_DEAL_TARGET);
  const growthHighestIndex = $growthDone.reduce(
    (highest, done, index) => (done ? index : highest),
    -1,
  );
  const growthCurrentText =
    growthHighestIndex < 0 ? '未达成' : `LV${growthHighestIndex + 1}`;
  const growthNextIndex =
    growthHighestIndex < GROWTH_LEVELS.length - 1
      ? growthHighestIndex + 1
      : GROWTH_LEVELS.length - 1;
  const growthNext = GROWTH_LEVELS[growthNextIndex];
  const growthNextText = `LV${growthNextIndex + 1}·奖励${growthNext.reward}元`;
  const configUnlocked = configDoneCount >= ONBOARD_CONFIG_COUNT;
  const dealUnlocked = dealDoneCount >= ONBOARD_DEAL_TARGET;
  const configReward = configUnlocked ? ONBOARD_CONFIG_REWARD : 0;
  const dealReward = dealUnlocked ? ONBOARD_DEAL_REWARD : 0;
  const growthReward =
    growthHighestIndex >= 0 ? GROWTH_LEVELS[growthHighestIndex].reward : 0;
  const estimatedReward = configReward + dealReward + growthReward;

  const startTime = activityDetailsPage.startTime;
  const endTime = activityDetailsPage.endTime;
  const rewardTime = activityDetailsPage.announceTime;
  const cashbackEnd = startTime ? startTime.add(30, 'day') : null;
  const endTimeText = endTime?.format('YYYY/MM/DD HH:mm') || 'YYYY/MM/DD HH:mm';

  async function openConsolePath(path: string) {
    if (!(await ensureLogin())) {
      return;
    }
    self.open(consoleUrl(path));
  }

  async function goCreateNodeTask() {
    if (!(await ensureLogin())) {
      return;
    }
    const nodeID = await pickNodeWithoutTheme();
    if (nodeID == null) {
      self.open(consoleUrl(FUtil.LinkTo.nodeCreator()));
      return;
    }
    self.open(
      consoleUrl(
        FUtil.LinkTo.nodeManagement({
          nodeID,
          showPage: 'theme',
        }),
      ),
    );
  }

  async function goSettlementTask() {
    if (!(await ensureLogin())) {
      return;
    }
    const nodes = await listUserNodes();
    const nodeID = nodes[0]?.nodeId;
    if (nodeID == null) {
      self.open(consoleUrl(FUtil.LinkTo.nodeCreator()));
      return;
    }
    self.open(
      consoleUrl(
        FUtil.LinkTo.nodeManagement({
          nodeID,
          showPage: 'income',
        }),
      ),
    );
  }

  async function goInviteFansTask() {
    if (!(await ensureLogin())) {
      return;
    }
    const nodes = await listUserNodes();
    const nodeID = nodes[0]?.nodeId;
    if (nodeID == null) {
      self.open(consoleUrl(FUtil.LinkTo.nodeCreator()));
      return;
    }
    const path = FUtil.LinkTo.nodeManagement({
      nodeID,
      showPage: 'exhibit',
    });
    const joiner = path.includes('?') ? '&' : '?';
    self.open(consoleUrl(`${path}${joiner}openShare=1#openShare=1`));
  }

  function shareActivity() {
    if (!user.userInfo) {
      FServiceAPI.User.currentUserInfo();
      return;
    }
    fWeiXinShare({
      configs: {
        title: activityDetailsPage.pageTitle,
        desc: activityDetailsPage.description,
        link: self.location.href,
        imgUrl: activityDetailsPage.cover,
      },
    });
  }

  async function joinActivity() {
    if (!(await ensureLogin())) {
      return;
    }
    scrollToSection(3);
  }

  return (
    <div className={[styles.root, isMobile ? styles.rootMobile : ''].join(' ')}>
      <img className={styles.banner} src={isMobile ? imgMPageBg : imgPageBg} alt='' />
      <FSimpleBar
        className={styles.scroller}
        onMount={(simpleBar) => {
          set$scroller(simpleBar.getScrollElement() as HTMLElement);
        }}
      >
        {!isMobile && (
        <div className={styles.column}>
          <img className={styles.title} src={imgTitle} alt='Freelog 创作者收益季' />

        <div className={styles.sectionSimulate}>
          <img src={imgSimulateBg} alt='收益多多，等你来拿' />
          <div className={styles.simulateSales}>{formatYenAuto($simulateSales)}</div>
          <div className={styles.simulateBar}>
            <i className={styles.simulateBarTrack} />
            <i className={styles.simulateBarFill} style={{ width: simulateBarFill }} />
            <svg
              className={styles.simulateBarThumb}
              width='24'
              height='24'
              viewBox='0 0 24 24'
              style={{ left: simulateThumbLeft }}
            >
              <path
                d='M12 0L22.3923 6L22.3923 18L12 24L1.6077 18L1.6077 6L12 0Z'
                fill='#044088'
                stroke='#D9D9D9'
                strokeWidth='1'
              />
            </svg>
            <input
              type='range'
              className={styles.simulateBarInput}
              min={SIMULATE_SALES_MIN}
              max={SIMULATE_SALES_MAX}
              step={1}
              value={$simulateSales}
              aria-label='售出作品总额'
              onChange={(e) => set$simulateSales(Number(e.target.value))}
            />
          </div>
          <div className={styles.simulateOrigin}>{formatYen(simulateOrigin, 2)}</div>
          <div className={styles.simulateOnboard}>+ ¥{SIMULATE_ONBOARD_REWARD}</div>
          <div className={styles.simulateGrowth}>+ ¥{simulateGrowth}</div>
          <div className={styles.simulateTotal}>{formatYenAuto(simulateTotal)}</div>
          <button
            type='button'
            className={styles.simulateBtnCreator}
            onClick={() => scrollToSection(3)}
          >
            查看更多
          </button>
          <button
            type='button'
            className={styles.simulateBtnFan}
            onClick={() => scrollToSection(4)}
          >
            查看更多
          </button>
        </div>

        <div className={styles.sectionWide} ref={ref_platform}>
          <img src={imgPlatform} alt='为什么选择 Freelog' />
        </div>

        <div className={styles.sectionTime} ref={ref_time}>
          <img src={imgTime} alt='活动时间' />
          {startTime && (
            <>
              <DatePatch
                left={104}
                top={346}
                width={172}
                height={42}
                fontSize={30}
                letterSpacing={0.6}
                background='#f2fbfb'
                text={startTime.format('YYYY/MM/DD')}
              />
              <DatePatch
                left={148}
                top={393}
                width={83}
                height={42}
                fontSize={30}
                letterSpacing={0.6}
                background='#f2fbfb'
                text={startTime.format('HH:mm')}
              />
            </>
          )}
          {endTime && (
            <>
              <DatePatch
                left={625}
                top={346}
                width={172}
                height={42}
                fontSize={30}
                letterSpacing={0.6}
                background='#faf3f3'
                text={endTime.format('YYYY/MM/DD')}
              />
              <DatePatch
                left={669}
                top={393}
                width={83}
                height={42}
                fontSize={30}
                letterSpacing={0.6}
                background='#faf3f3'
                text={endTime.format('HH:mm')}
              />
            </>
          )}
          {cashbackEnd && (
            <>
              <DatePatch
                left={479}
                top={553}
                width={115}
                height={28}
                fontSize={20}
                letterSpacing={0.4}
                background='#faf5ee'
                text={cashbackEnd.format('YYYY/MM/DD')}
              />
              <DatePatch
                left={614}
                top={553}
                width={56}
                height={28}
                fontSize={20}
                letterSpacing={0.4}
                background='#faf5ee'
                text={cashbackEnd.format('HH:mm')}
              />
            </>
          )}
          {rewardTime && (
            <>
              <DatePatch
                left={479}
                top={693}
                width={115}
                height={28}
                fontSize={20}
                letterSpacing={0.4}
                background='#faf5ee'
                text={rewardTime.format('YYYY/MM/DD')}
              />
              <DatePatch
                left={614}
                top={693}
                width={56}
                height={28}
                fontSize={20}
                letterSpacing={0.4}
                background='#faf5ee'
                text={rewardTime.format('HH:mm')}
              />
            </>
          )}
        </div>

        <div className={styles.sectionWide} ref={ref_benefits}>
          <img src={imgBenefits} alt='活动权益' />
        </div>

        <div className={styles.sectionOnboard} ref={ref_onboard}>
          <img src={imgOnboardBg} alt='创作者入驻任务' />
          <div className={styles.onboardCards}>
            {[
              {
                img: imgOnboard1,
                done: $onboardDone[0],
                onClick: () => openConsolePath(FUtil.LinkTo.invitation()),
              },
              {
                img: imgOnboard2,
                done: $onboardDone[1],
                onClick: () => openConsolePath(FUtil.LinkTo.resourceCreatorEntry()),
              },
              {
                img: imgOnboard3,
                done: $onboardDone[2],
                onClick: goCreateNodeTask,
              },
              {
                img: imgOnboard4,
                done: $onboardDone[3],
                onClick: goSettlementTask,
              },
              {
                img: imgOnboard5,
                done: $onboardDone[4],
                onClick: () => openConsolePath(FUtil.LinkTo.myResources()),
              },
              {
                img: imgOnboard6,
                done: $onboardDone[5],
                onClick: goInviteFansTask,
              },
            ].map((task) => (
              <div key={task.img} className={styles.onboardCard}>
                <img src={task.img} alt='' />
                {task.done ? (
                  <div className={styles.onboardDone} title='已完成'>
                    <svg width='24' height='24' viewBox='0 0 24 24' aria-hidden>
                      <circle cx='12' cy='12' r='12' fill='#44C28C' />
                      <path
                        d='M7 12.5l3.2 3.2L17.5 8.5'
                        stroke='#fff'
                        strokeWidth='2'
                        fill='none'
                        strokeLinecap='round'
                        strokeLinejoin='round'
                      />
                    </svg>
                    已完成
                  </div>
                ) : (
                  <button
                    type='button'
                    className={styles.onboardGo}
                    onClick={task.onClick}
                  >
                    去完成
                  </button>
                )}
              </div>
            ))}
          </div>
          <button
            type='button'
            className={styles.onboardGuide}
            onClick={() => self.open(ONBOARD_GUIDE_URL)}
          >
            <b>查看入驻指南</b>
            <span>了解结算配置、作品发布与节点搭建等步骤</span>
          </button>
        </div>

        <div className={styles.sectionGrowth}>
          <img src={imgGrowthBg} alt='成长等级任务' />
          <div className={styles.growthLevels}>
            {GROWTH_LEVEL_IMGS.map((img, index) => (
              <div
                key={img}
                className={[
                  styles.growthLevel,
                  index === growthHighestIndex ? styles.growthLevelLit : '',
                ].join(' ')}
              >
                <img src={img} alt={`LV${index + 1}`} />
              </div>
            ))}
          </div>
          <div className={styles.growthActions}>
            <button
              type='button'
              className={styles.growthBtn}
              onClick={() => openConsolePath(FUtil.LinkTo.resourceCreatorEntry())}
            >
              <b>发布更多作品</b>
              <span>增加可售内容供给，让粉丝有更多支持入口。</span>
            </button>
            <button
              type='button'
              className={styles.growthBtn}
              onClick={goInviteFansTask}
            >
              <b>分享主页</b>
              <span>将节点分享给粉丝，粉丝直接下单，支付时即享20%消费补贴。</span>
            </button>
          </div>
        </div>

        <div className={styles.sectionWide} ref={ref_cashback}>
          <img src={imgCashback} alt='粉丝消费补贴' />
        </div>

        <div className={styles.sectionRules} ref={ref_rules}>
          <img src={imgRules} alt='活动规则' />
          <div className={styles.rulesContent}>
            <RulesContent endTimeText={endTimeText} />
          </div>
        </div>

        <div className={styles.sectionFaq} ref={ref_faq}>
          <div className={styles.faqMain}>
            <img className={styles.faqTitle} src={imgFaqTitle} alt='常见问题' />
            <div className={styles.faqList}>
              {FAQ_ITEMS.map((item, index) => {
                const open = $faqOpen === index;
                return (
                  <div key={item.question} className={styles.faqItem}>
                    <button
                      type='button'
                      className={styles.faqQuestion}
                      aria-expanded={open}
                      onClick={() => set$faqOpen(open ? -1 : index)}
                    >
                      <span>{item.question}</span>
                      <svg
                        className={styles.faqIcon}
                        width='16'
                        height='16'
                        viewBox='0 0 16 16'
                        aria-hidden
                      >
                        {open ? (
                          <rect y='7' width='16' height='2' fill='#044088' />
                        ) : (
                          <>
                            <rect x='7' width='2' height='16' fill='#044088' />
                            <rect y='7' width='16' height='2' fill='#044088' />
                          </>
                        )}
                      </svg>
                    </button>
                    {open && (
                      <div className={styles.faqAnswer}>
                        {item.paragraphs.map((text) => (
                          <p key={text}>{text}</p>
                        ))}
                        {item.bullets && (
                          <ul>
                            {item.bullets.map((text) => (
                              <li key={text}>{text}</li>
                            ))}
                          </ul>
                        )}
                        {item.tail?.map((text) => (
                          <p key={text}>{text}</p>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
          <div className={styles.faqFooter}>更多活动相关咨询可联系下方官方渠道</div>
        </div>

        <div className={styles.sectionConsult} ref={ref_consult}>
          <img className={styles.consultTitle} src={imgConsultTitle} alt='活动咨询' />
          <div className={styles.consultGrid}>
            {CONSULT_CHANNELS.map((item) => (
              <div key={item.tag} className={styles.consultCard}>
                <div className={styles.consultCardText}>
                  <div className={styles.consultCardTitle}>{item.title}</div>
                  <div className={styles.consultCardTag}>{item.tag}</div>
                </div>
                <div className={item.round ? styles.consultAvatar : styles.consultQr}>
                  <img src={item.img} alt={item.title} />
                </div>
              </div>
            ))}
          </div>
        </div>
        </div>
        )}
        {isMobile && (
          <div className={styles.mColumn}>
            <img className={styles.mTitleImg} src={imgMTitle} alt='Freelog 创作者收益季 限时开启' />

            <div className={styles.mSim}>
              <div className={styles.mSimTabs}>
                <button
                  type='button'
                  className={[
                    styles.mSimTab,
                    $simulateTab === 'creator' ? styles.mSimTabActive : '',
                  ].join(' ')}
                  onClick={() => set$simulateTab('creator')}
                >
                  我是创作者
                </button>
                <button
                  type='button'
                  className={[
                    styles.mSimTab,
                    $simulateTab === 'fan' ? styles.mSimTabFanActive : '',
                  ].join(' ')}
                  onClick={() => set$simulateTab('fan')}
                >
                  我是粉丝
                </button>
              </div>
              {$simulateTab === 'creator' ? (
                <>
                  <div className={styles.mSimHead}>
                    <div className={styles.mSimHeadRow}>
                      <span>假如我的售出作品总额是</span>
                      <i>按最高等级达成</i>
                    </div>
                    <div className={styles.mSimSales}>{formatYenAuto($simulateSales)}</div>
                    <div className={styles.mSimBar}>
                      <i className={styles.mSimBarTrack} />
                      <i
                        className={styles.mSimBarFill}
                        style={{ width: `${simulateBarRatio * 100}%` }}
                      />
                      <svg
                        className={styles.mSimBarThumb}
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        style={{
                          left: `clamp(0px, calc(${simulateBarRatio * 100}% - 12px), calc(100% - 24px))`,
                        }}
                      >
                        <path
                          d='M12 0L22.3923 6L22.3923 18L12 24L1.6077 18L1.6077 6L12 0Z'
                          fill='#044088'
                          stroke='#D9D9D9'
                          strokeWidth='1'
                        />
                      </svg>
                      <input
                        type='range'
                        className={styles.mSimBarInput}
                        min={SIMULATE_SALES_MIN}
                        max={SIMULATE_SALES_MAX}
                        step={1}
                        value={$simulateSales}
                        aria-label='售出作品总额'
                        onChange={(e) => set$simulateSales(Number(e.target.value))}
                      />
                    </div>
                  </div>
                  <div className={styles.mSimRows}>
                    <div className={styles.mSimRow}>
                      <span>原本到账</span>
                      <b>{formatYen(simulateOrigin, 2)}</b>
                    </div>
                    <div className={styles.mSimRow}>
                      <span>完成入驻任务</span>
                      <b>+ ¥{SIMULATE_ONBOARD_REWARD}</b>
                    </div>
                    <div className={styles.mSimRow}>
                      <span>成长等级激励</span>
                      <b>+ ¥{simulateGrowth}</b>
                    </div>
                  </div>
                  <div className={styles.mSimTotal}>
                    <span>预计最终到手</span>
                    <strong>{formatYenAuto(simulateTotal)}</strong>
                  </div>
                </>
              ) : (
                <img
                  className={styles.mSimFan}
                  src={imgMSimFan}
                  alt='活动首月限时开启！支持创作者，即享20%消费补贴'
                />
              )}
              <button
                type='button'
                className={[
                  styles.mSimMore,
                  $simulateTab === 'fan' ? styles.mSimMoreFan : '',
                ].join(' ')}
                onClick={() => scrollToSection($simulateTab === 'fan' ? 4 : 3)}
              >
                查看更多
              </button>
            </div>

            <div className={[styles.mCard, styles.mCardPlatform].join(' ')} ref={ref_platform}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>为什么选择Freelog</h2>
              <div className={styles.mPointList}>
                {PLATFORM_POINTS.map((item) => (
                  <div key={item.title} className={styles.mPoint}>
                    <div>
                      <b style={{ color: item.titleColor }}>{item.title}</b>
                      {item.lines.map((line) => (
                        <span key={line}>{line}</span>
                      ))}
                    </div>
                    <img src={item.icon} alt='' />
                  </div>
                ))}
              </div>
              <div className={styles.mTypes}>
                <div className={styles.mTypesTitle}>Freelog支持以下创作者入驻</div>
                <div className={styles.mTypeGrid}>
                  {CREATOR_TYPES.map((item) => (
                    <div key={item.name} className={styles.mType}>
                      <img src={item.icon} alt='' />
                      <b>{item.name}</b>
                      <span>{item.desc}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className={styles.mCard} ref={ref_time}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>活动时间</h2>
              <div className={styles.mTimeList}>
                <div className={styles.mTimeCard}>
                  <b className={styles.mTimeStart}>活动开始</b>
                  <span>
                    {startTime ? startTime.format('YYYY/MM/DD  HH:mm') : '2026/XX/XX  00:00'}
                  </span>
                </div>
                <div className={styles.mTimeCard}>
                  <b className={styles.mTimeEnd}>活动结束</b>
                  <span>
                    {endTime ? endTime.format('YYYY/MM/DD  HH:mm') : '2026/XX/XX  00:00'}
                  </span>
                </div>
                <div className={[styles.mTimeCard, styles.mTimeCardSub].join(' ')}>
                  <b>消费补贴截止时间</b>
                  <p>消费补贴仅在活动开启后的前 30 天开放</p>
                  <span>
                    {cashbackEnd
                      ? cashbackEnd.format('YYYY/MM/DD  HH:mm')
                      : '2026/XX/XX  00:00'}
                  </span>
                </div>
                <div className={[styles.mTimeCard, styles.mTimeCardSub].join(' ')}>
                  <b>奖励发放时间</b>
                  <p>活动结束并完成数据审核后统一发放</p>
                  <span>
                    {rewardTime
                      ? rewardTime.format('YYYY/MM/DD  HH:mm')
                      : '2026/XX/XX  00:00'}
                  </span>
                </div>
              </div>
            </div>

            <div className={styles.mCard} ref={ref_benefits}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>活动权益</h2>
              <div className={styles.mBenList}>
                {BENEFIT_CARDS.map((item) => (
                  <div key={item.title} className={styles.mBen}>
                    <img src={item.icon} alt='' />
                    <b style={{ color: item.color }}>{item.title}</b>
                    <span>{item.desc}</span>
                    <strong style={{ color: item.color }}>{item.amount}</strong>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.mCard} ref={ref_onboard}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>参与方式（一）</h2>
              <div className={styles.mLead}>
                <b>创作者入驻任务</b>
                <span>
                  完成任务 01至05，解锁 50 元入驻配置奖励；完成任务 06，再解锁 50 元首批成交奖励。
                </span>
              </div>
              <div className={styles.mTaskList}>
                {ONBOARD_MOBILE.map((item) => (
                  <div key={item.no} className={styles.mTask}>
                    <div className={styles.mTaskHead}>
                      <i>{item.no}</i>
                      <div>
                        <b>{item.title}</b>
                        <span>{item.desc}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div className={styles.mCard}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>参与方式（二）</h2>
              <div className={styles.mLead}>
                <b>成长等级任务</b>
                <span>
                  作品累计成交金额和付费粉丝数达到对应目标，即可冲刺更高奖励，最终按最高达成等级发放。
                </span>
              </div>
              <div className={styles.mLvList}>
                {GROWTH_LEVELS.map((item, index) => (
                  <div key={item.reward} className={styles.mLv}>
                    <div className={styles.mLvHead}>
                      <i>LV{index + 1}</i>
                      <div>
                        <b>作品成交满 {item.sales} 元</b>
                        <span>有效付费用户≥ {item.users} 人</span>
                      </div>
                    </div>
                    <strong>奖励{item.reward}元</strong>
                  </div>
                ))}
              </div>
            </div>

            <div className={[styles.mCard, styles.mCardCash].join(' ')} ref={ref_cashback}>
              <div className={styles.mCashHero}>
                <span className={styles.mCashHeroTag}>FOR FANS</span>
                <div className={styles.mCashHeroRow}>
                  <div className={styles.mCashHeroTitle}>
                    <b>活动首月</b>
                    <b>消费立减</b>
                  </div>
                  <strong className={styles.mCashHeroPct}>20%</strong>
                </div>
              </div>
              <div className={styles.mCashIntro}>
                <div className={styles.mCashIntroHead}>
                  <span>符合条件的订单</span>
                  <b>支付时自动享受平台补贴</b>
                </div>
                <p className={styles.mCashIntroBody}>
                  粉丝通过创作者分享入口购买作品，符合条件的订单支付时自动享受平台补贴，直接抵扣订单应付金额；每位用户每天仅有1次补贴机会，每日补贴额度有限，按支付顺序先到先得，补完即止。
                </p>
              </div>
              <div className={styles.mFactList}>
                {CASHBACK_FACTS.map((item) => (
                  <div key={item.label} className={styles.mFact}>
                    <span>{item.label}</span>
                    <b>{item.value}</b>
                  </div>
                ))}
              </div>
            </div>

            <div className={[styles.mCard, styles.mCardInset].join(' ')} ref={ref_rules}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>活动规则</h2>
              <div className={styles.mRulesContent}>
                <RulesContent endTimeText={endTimeText} />
              </div>
            </div>

            <div className={[styles.mCard, styles.mCardInset].join(' ')} ref={ref_faq}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>常见问题</h2>
              <div className={styles.mFaqList}>
                {FAQ_ITEMS.map((item, index) => {
                  const open = $faqOpen === index;
                  return (
                    <div key={item.question} className={styles.mFaqItem}>
                      <button
                        type='button'
                        className={styles.mFaqQ}
                        aria-expanded={open}
                        onClick={() => set$faqOpen(open ? -1 : index)}
                      >
                        <span>{item.question}</span>
                        <svg width='14' height='14' viewBox='0 0 14 14' aria-hidden>
                          {open ? (
                            <rect y='6' width='14' height='2' fill='#044088' />
                          ) : (
                            <>
                              <rect x='6' width='2' height='14' fill='#044088' />
                              <rect y='6' width='14' height='2' fill='#044088' />
                            </>
                          )}
                        </svg>
                      </button>
                      {open && (
                        <div className={styles.mFaqA}>
                          {item.paragraphs.map((text) => (
                            <p key={text}>{text}</p>
                          ))}
                          {item.bullets && (
                            <ul>
                              {item.bullets.map((text) => (
                                <li key={text}>{text}</li>
                              ))}
                            </ul>
                          )}
                          {item.tail?.map((text) => (
                            <p key={text}>{text}</p>
                          ))}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              <i className={styles.mFaqLine} />
              <div className={styles.mFaqFoot}>更多活动相关咨询可联系下方官方渠道</div>
            </div>

            <div className={[styles.mCard, styles.mCardInset].join(' ')} ref={ref_consult}>
              <h2 className={[styles.mH2, styles.mH2Center].join(' ')}>活动咨询</h2>
              <div className={styles.mConsultList}>
                {CONSULT_CHANNELS.map((item) => (
                  <div key={item.tag} className={styles.mConsult}>
                    <div className={styles.mConsultText}>
                      <span>{item.tag}</span>
                      <b>{item.title}</b>
                      <button
                        type='button'
                        className={styles.mConsultBtn}
                        onClick={() => {
                          if (item.action === 'save') {
                            saveConsultImage(item.img, `${item.tag}.png`);
                            return;
                          }
                          if (item.action === 'xiaohongshu') {
                            self.open(XIAOHONGSHU_URL);
                            return;
                          }
                          self.open(WEIBO_URL);
                        }}
                      >
                        {item.actionLabel}
                      </button>
                    </div>
                    <div className={item.round ? styles.mConsultAvatar : styles.mConsultQr}>
                      <img src={item.img} alt={item.title} />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
      </FSimpleBar>

      {!isMobile && (
      <>
      <nav className={styles.nav} aria-label='页面导航'>
        {NAV_ITEMS.map((item, index) => (
          <div
            key={item.label}
            className={[
              styles.navItem,
              $activated === index ? styles.navItemActive : '',
            ].join(' ')}
            onClick={() => scrollToSection(index)}
          >
            <img src={item.icon} alt='' />
            <span>{item.label}</span>
          </div>
        ))}
      </nav>

      <aside
        className={[
          styles.panelWrap,
          $panelCollapsed ? styles.panelWrapCollapsed : '',
        ].join(' ')}
      >
        <div className={styles.panelCardRow}>
          <button
            type='button'
            className={styles.panelToggle}
            aria-label={$panelCollapsed ? '展开' : '收起'}
            aria-expanded={!$panelCollapsed}
            onClick={() => set$panelCollapsed((v) => !v)}
          >
            <svg width='8' height='12' viewBox='0 0 8 12' aria-hidden>
              {$panelCollapsed ? (
                <path d='M8 0L0 6l8 6z' fill='#fff' />
              ) : (
                <path d='M0 0l8 6-8 6z' fill='#fff' />
              )}
            </svg>
          </button>
          <div className={styles.panel} aria-hidden={$panelCollapsed}>
              <div className={styles.panelBlock}>
                <div className={styles.panelHead}>
                  <span>任务进度</span>
                  <span>
                    {totalDoneCount}/{ONBOARD_TASK_CODES.length}
                  </span>
                </div>
                <div className={styles.panelBar}>
                  <i
                    style={{
                      width: `${(totalDoneCount / ONBOARD_TASK_CODES.length) * 100}%`,
                    }}
                  />
                </div>
                <div className={styles.panelSub}>
                  <span>当前待完成</span>
                  <b>{pendingTaskTitle}</b>
                </div>
                <div className={styles.panelTasks}>
                  <div className={styles.panelCard}>
                    <div className={styles.panelCardTitle}>
                      <b>入驻配置</b>
                      <span>（任务01-05）</span>
                    </div>
                    <div className={styles.panelCardValue}>
                      {configDoneCount} / {ONBOARD_CONFIG_COUNT} 项
                    </div>
                    <div className={styles.panelCardHint}>
                      {configUnlocked ? '已解锁50元' : '待解锁50元'}
                    </div>
                  </div>
                  <div className={styles.panelCard}>
                    <div className={styles.panelCardTitle}>
                      <b>首批成交</b>
                      <span>（任务06）</span>
                    </div>
                    <div className={styles.panelCardValue}>
                      {dealDoneCount} / {ONBOARD_DEAL_TARGET} 笔
                    </div>
                    <div className={styles.panelCardHint}>
                      {dealUnlocked ? '已解锁50元' : '待解锁50元'}
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.panelBlock}>
                <div className={styles.panelHead}>
                  <span>成长等级</span>
                  <span>{growthCurrentText}</span>
                </div>
                <div className={styles.panelLevel}>
                  <div className={styles.panelLevelRow}>
                    <span>下一目标</span>
                    <b>{growthNextText}</b>
                  </div>
                  <div className={styles.panelLevelLine} />
                  <div className={styles.panelMetric}>
                    <div className={styles.panelMetricRow}>
                      <span>作品成交</span>
                      <b>
                        {formatYenAuto($growthSales)}/{formatYenAuto(growthNext.sales)}
                      </b>
                    </div>
                    <div className={styles.panelMiniBar}>
                      <i style={{ width: miniBarWidth($growthSales, growthNext.sales) }} />
                    </div>
                  </div>
                  <div className={styles.panelMetric}>
                    <div className={styles.panelMetricRow}>
                      <span>有效付费用户</span>
                      <b>
                        {$growthUsers}/{growthNext.users}
                      </b>
                    </div>
                    <div className={styles.panelMiniBar}>
                      <i style={{ width: miniBarWidth($growthUsers, growthNext.users) }} />
                    </div>
                  </div>
                </div>
              </div>

              <div className={styles.panelReward}>
                <div>当前预计活动奖励</div>
                <strong>{formatYenAuto(estimatedReward)}</strong>
              </div>
              <button
                type='button'
                className={styles.panelBtnOutline}
                onClick={() => scrollToSection(3)}
              >
                查看全部任务
              </button>
            </div>
        </div>
        <div className={styles.panelActions}>
            <button type='button' className={styles.panelBtnPrimary} onClick={joinActivity}>
              立即参与
            </button>
            <button type='button' className={styles.panelBtnShare} onClick={shareActivity}>
              分享活动
            </button>
        </div>
      </aside>
      </>
      )}

      {isMobile && (
        <div className={styles.mBottom}>
          <button
            type='button'
            className={styles.mBottomBtn}
            onClick={() => set$mJoinOpen(true)}
          >
            <img src={imgMIconJoin} alt='' />
            立即参与
          </button>
          <i className={styles.mBottomSplit} />
          <button
            type='button'
            className={styles.mBottomBtn}
            onClick={() => set$mShareOpen(true)}
          >
            <img src={imgMIconShare} alt='' />
            分享活动
          </button>
        </div>
      )}

      <FModal
        open={$mShareOpen}
        width={317}
        centered
        closable={false}
        maskClosable={true}
        onCancel={() => set$mShareOpen(false)}
        style={{ borderRadius: 20, overflow: 'hidden', padding: 0 }}
        styles={{
          content: {
            borderRadius: 20,
            overflow: 'hidden',
            padding: 0,
            boxShadow: 'none',
          },
          body: { borderRadius: 20, overflow: 'hidden', padding: 0 },
        }}
      >
        <div className={styles.mShareModal}>
          <img className={styles.mShareIcon} src={imgMIconShare} alt='' />
          <div className={styles.mShareText}>
            <span>请使用浏览器的分享功能</span>
            <span>将活动页分享给好友</span>
          </div>
        </div>
      </FModal>

      <FModal
        open={$mJoinOpen}
        width={317}
        centered
        closable={false}
        maskClosable={true}
        onCancel={() => set$mJoinOpen(false)}
        style={{ borderRadius: 20, overflow: 'hidden', padding: 0 }}
        styles={{
          content: {
            borderRadius: 20,
            overflow: 'hidden',
            padding: 0,
            boxShadow: 'none',
          },
          body: { borderRadius: 20, overflow: 'hidden', padding: 0 },
        }}
      >
        <div className={styles.mJoinModal}>
          <img className={styles.mJoinIcon} src={imgMIconConsole} alt='' />
          <div className={styles.mJoinTitle}>请前往 PC 端参与活动</div>
          <div className={styles.mJoinDesc}>
            移动端暂不提供参与入口，请使用电脑打开活动页面参与活动。
          </div>
        </div>
      </FModal>
    </div>
  );
}

export default connect(({ activityDetailsPage, user }: ConnectState) => ({
  activityDetailsPage,
  user,
}))(PaymentSubsidy);
